module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-73.6ed2b72.woff2";